import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Seo } from "@/components/Seo";
import { Hero } from "@/components/sections/Hero";
import { About } from "@/components/sections/About";
import { Athletics } from "@/components/sections/Athletics";
import { MomentBand } from "@/components/sections/MomentBand";
import { Journey } from "@/components/sections/Journey";
import { News } from "@/components/sections/News";
import { Blog } from "@/components/sections/Blog";
import { Partnerships } from "@/components/sections/Partnerships";
import { Sponsorship } from "@/components/sections/Sponsorship";
import { Contact } from "@/components/sections/Contact";
import { NewsletterSection } from "@/components/sections/NewsletterSection";

export default function OnePage() {
  const [news, setNews] = useState([]);
  const [embeds, setEmbeds] = useState([]);
  const [results, setResults] = useState([]);
  const [settings, setSettings] = useState({});
  const [sponsors, setSponsors] = useState([]);

  useEffect(() => {
    api.get("/news").then(({ data }) => setNews(data)).catch(() => {});
    api.get("/embeds").then(({ data }) => setEmbeds(data)).catch(() => {});
    api.get("/results").then(({ data }) => setResults(data)).catch(() => {});
    api.get("/settings").then(({ data }) => setSettings(data)).catch(() => {});
    api.get("/sponsors").then(({ data }) => setSponsors(data)).catch(() => {});
    if (window.location.hash) {
      const id = window.location.hash.replace("#", "");
      setTimeout(() => document.getElementById(id)?.scrollIntoView({ behavior: "smooth" }), 200);
    }
  }, []);

  return (
    <div data-testid="home-page">
      <Seo
        title="Leah Thames | Professional 400m & 200m Sprinter"
        description="Leah Thames is a professional 400m & 200m sprinter and relay athlete, 2026 MVC Champion and NCAA qualifier. Explore her results, story, sponsorships, and The Fab Lab."
        path="/"
      />
      <Hero />
      <About />
      <Athletics />
      <MomentBand />
      <Journey embeds={embeds} results={results} settings={settings} />
      <News news={news} />
      <Blog news={news} />
      <Partnerships />
      <Sponsorship sponsors={sponsors} />
      <Contact />
      <NewsletterSection />
    </div>
  );
}
